import Vue from "vue";
// ant
import "./ant-vue";

// 图片放大查看
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
Vue.use(Viewer)